module.exports = "<th ng-repeat-start=\"col in datagridCtrl.cols\" ng-if=\"$first\">\n\t<input type=\"checkbox\" ng-model=\"datagridCtrl.$allChecked\" ng-change=\"datagridCtrl.checkAll()\"/>\n</th>\n<th ng-repeat-end ng-if=\"!$first\">{{col.label}}</th>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/modules/demo/partials/datagrid/checkbox-header-cell.html
 ** module id = 126
 ** module chunks = 1
 **/